export const soundHirePackages = [
  {
    id: 'basic-indoor',
    name: 'Basic sound/ PA speaker',
    description: 'Ideal for simple events needing clear sound and one microphone.',
    price: 950,
    priceLabel: 'R950 per event/day',
    image: 'https://images.unsplash.com/photo-1520699049327-3b2b7d63f9e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    features: ['1 mic cordless', '1 PA system speaker'],
  },
  {
    id: 'standard-event',
    name: 'Standard Event Sound',
    description: 'Perfect for medium events that need fuller sound coverage.',
    price: 2500,
    priceLabel: 'R2,500 per event/day',
    image: '/standard-sound.png',
    features: ['2 powerd speakers', '1x bass bin or subwoofer', '2x cordless mic', 'Setup support'],
  },
  {
    id: 'outdoor-package',
    name: 'Outdoor Sound Package',
    description:
      'Best for outdoor functions, community events, team building, and larger private gatherings.',
    price: 3500,
    priceLabel: 'R3,500 per event/day',
    image: 'https://images.unsplash.com/photo-1507874457470-272b3c8d8ee2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    features: [
      '4 speakers',
      '2 microphones',
      'mixer',
      'stands',
      'setup support',
    ],
  },
  {
    id: 'premium-celebration',
    name: 'Premium Celebration Sound',
    description:
      'Best for weddings, premium celebrations, and corporate events.',
    price: 5500,
    priceLabel: 'from R5,500 per event/day',
    image: 'https://images.unsplash.com/photo-1524368535928-7b4a17b4a39e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    features: [
      'full speaker setup',
      'wireless microphones',
      'mixer/controller',
      'technician',
      'setup and breakdown',
    ],
  },
];

export const soundAddOns = [
  {
    id: 'dj-for-hire',
    name: 'DJ for hire',
    description: 'Professional DJ support to keep your celebration flowing.',
    price: 4000,
    priceLabel: 'from R4,000',
    image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  },
  {
    id: 'mc-for-hire',
    name: 'MC for hire',
    description: 'Experienced MC support for announcements and event flow.',
    price: 3000,
    priceLabel: 'from R3,000',
    image: 'https://images.unsplash.com/photo-1516280440614-37939bbacd81?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  },
  {
    id: 'stage-and-lighting',
    name: 'Stage and lighting',
    description: 'Stage and lighting setup to elevate your event atmosphere.',
    price: 0,
    priceLabel: 'price on request',
    image: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  },
  {
    id: 'extra-microphone',
    name: 'Extra microphone',
    description: 'Add more microphones for speeches, MCs, or panel sessions.',
    price: 250,
    image: 'https://images.unsplash.com/photo-1520699049337-4b6d9d0f5fb8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  },
  {
    id: 'technician-on-site',
    name: 'Technician on-site',
    description: 'Reliable on-site support for smooth sound throughout the event.',
    price: 850,
    image: 'https://images.unsplash.com/photo-1520699049327-3b2b7d63f9e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  },
  {
    id: 'additional-speaker',
    name: 'Additional speaker',
    description: 'Improve coverage for larger rooms or outdoor spaces.',
    price: 600,
    image: 'https://images.unsplash.com/photo-1545239351-1141bd82e8a6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  },
  {
    id: 'lighting-add-on',
    name: 'Lighting add-on',
    description: 'Add a tasteful lighting accent to complement your sound setup.',
    price: 1200,
    image: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  },
  {
    id: 'smoke-machine-add-on',
    name: 'Smoke machine add-on',
    description:
      'Quick smoke effect option to elevate entrances, dance floors, and stage moments.',
    price: 650,
    image: 'https://images.unsplash.com/photo-1507874457470-272b3c8d8ee2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  },
];

export const smokeMachinePackages = [
  {
    id: 'basic-smoke',
    name: 'Basic Smoke Machine',
    description: 'Suitable for small indoor functions.',
    price: 450,
    priceLabel: 'R450 per event/day',
    image: 'https://images.unsplash.com/photo-1552552770-7f8d88d2fa2a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    features: ['machine + standard fluid'],
  },
  {
    id: 'event-smoke',
    name: 'Event Smoke Package',
    description: 'Suitable for parties and mid-size events.',
    price: 850,
    priceLabel: 'R850 per event/day',
    image: 'https://images.unsplash.com/photo-1464381577140-3e3b1c3c4b3b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    features: ['machine + fluid + delivery/setup'],
  },
  {
    id: 'premium-effects',
    name: 'Premium Effects Package',
    description:
      'Suitable for weddings, stages, entrances, dance floors, and premium moments.',
    price: 1650,
    priceLabel: 'R1,650 per event/day',
    image: 'https://images.unsplash.com/photo-1524368535928-7b4a17b4a39e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    features: ['high-output machine + fluid + operator/setup'],
  },
];

export const venueSupportPackages = [
  {
    id: 'venue-search',
    name: 'Venue Search Assistance',
    description:
      'Shortlist venue options based on your event brief and preferences.',
    price: 850,
    priceLabel: 'R850 consultation',
    image: 'https://images.unsplash.com/photo-1520962917966-7e8bb4f0b9b9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    features: ['shortlisting', 'event brief matching', 'recommendations'],
  },
  {
    id: 'venue-booking',
    name: 'Venue Booking Assistance',
    description:
      'Communicate with venues, confirm availability, and support booking coordination.',
    price: 1500,
    priceLabel: 'R1,500 service fee',
    image: 'https://images.unsplash.com/photo-1528909514045-2fa4ac7a08ba?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    features: ['availability coordination', 'booking support', 'confirmation follow-ups'],
  },
  {
    id: 'venue-coordination',
    name: 'Full Venue Coordination',
    description:
      'Venue sourcing + booking assistance + coordination support with your other event services.',
    price: 3500,
    priceLabel: 'R3,500 service fee',
    image: 'https://images.unsplash.com/photo-1526401485004-2aa7c7a0b1c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    features: ['sourcing', 'booking assistance', 'coordination support'],
  },
];

